import axios from 'axios';

const instance = axios.create({
    //baseURL: 'https://gestuftelernhilfen.diluna.ch'
    baseURL: process.env.REACT_APP_FB_LINK
});

export default instance;